import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { HiPresentationChartBar, HiDocumentText, HiDatabase, HiLogout } from 'react-icons/hi'
import Logo from '../assets/images/logo_analidys.png'
import { useAuth } from "../context/AuthProvider";

const Sidebar = () => {
    const { auth, signOut } = useAuth();
    // const [open, setOpen] = useState(false)
    const location = useLocation()

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
          const { error } = await signOut();
          console.log(error);
        } catch (error) {
          console.log(error);
        }
      };

    const Menus = [
        { title: 'Analyse', path: '/analyse', src: <HiPresentationChartBar /> },
        { title: 'Documentation', path: '/documentation', src: <HiDocumentText /> },
        { title: 'Historique', path: '/history', src: <HiDatabase /> },
        { title: 'Déconnexion', path: '/logout', src: <HiLogout />, onClick: handleLogout },
        // { title: 'CGU', path: '/cgu', src: <HiDocumentText /> },
    ]

    return (
        <>
            <div
                className={`w-64 hidden sm:block relative min-h-screen duration-300 bg-white border-r border-gray-300 p-5`}
            >
                {/* <HiOutlineArrowLeft
                    className={`rotate-180 absolute text-xl bg-white fill-slate-800 rounded-md cursor-pointer  top-9 -right-1`}
                    onClick={() => setOpen(!open)}
                /> */}
                <Link to='/'>
                    <div className={`w-50 h-50 items-center`}>
                        <img src={Logo} alt='' className='pl-2' />
                    </div>
                </Link>


                <ul className='pt-6'>
                    {Menus.map((menu, index) => (
                        <Link to={menu.path} key={index}>
                            {auth && ( <li
                                className={`flex items-center gap-x-6 p-3 text-base font-normal rounded-lg cursor-pointer hover:bg-gray-100
                        ${menu.gap ? 'mt-9' : 'mt-2'} ${
                                    location.pathname === menu.path &&
                                    'bg-gray-100'
                                }`}
                                onClick={menu.onClick}
                            >
                                <span className='text-3xl'>{menu.src}</span>
                                <span
                                    className={`origin-left text-lg font-medium duration-300 hover:block`}
                                >
                                    {menu.title}
                                </span>
                            </li> )}
                        </Link>
                    ))}
                </ul>
            </div>
        </>
    )
}

export default Sidebar
